import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { Console } from '@angular/core/src/console';

@Injectable()
export class TerminadaApiService {
  data: any[] = [];

  terminadaURL: string = config.API_DATA_URL + "/terminada";

  constructor(public http: HttpClient) {}

  public getTerminadaData(idOS: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.terminadaURL + "/GetUnidadTerminada/" + idOS, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public ActualizarObservaciones(terminada: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(terminada);
    // console.log(param);
    return this.http
      .post(this.terminadaURL + "/ActualizarObservaciones", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarCostos(terminada: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(terminada);
    // console.log(param);
    return this.http
      .post(this.terminadaURL + "/ActualizarCostos", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public EliminarFoto(terminada: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(terminada);
    // console.log(param);
    return this.http
      .post(this.terminadaURL + "/EliminarFoto", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public UnidadTerminada(terminada: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(terminada);
    // console.log(param);
    return this.http
      .post(this.terminadaURL + "/AceptarUnidadTerminada", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  private getBaseUrl() {
    return (
      location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "") +
      "/"
    );
  }

  private getHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : "Server error";
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/terminada-api.service.ts